import {
  Button,
  Card,
  Container,
  Grid,
  IconButton,
  Stack,
  Tooltip,
  Typography
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CustomerInsertUpdateModal from "./CustomerInsertUpdateModal";
import { getCustomerApi, deleteCustomerApi } from "src/api/customerApi";
import DataTable from "react-data-table-component";
import { DeleteSharp, EditSharp } from "@mui/icons-material";
import Deletemodal from "src/pages/DeleteModal";
import { notification } from "src/utils/messages";

export default function Index() {
  const [addEditModal, setAddEditModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState({ mval: false, id: 0 });
  const [modalType, setModalType] = useState("Add");
  const [customerData, setCustomerData] = useState([]);
  const [page, setPage] = useState(1);
  const [rowData, setRowData] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const toggleAddEditModal = () => setAddEditModal(!addEditModal);

  const getCustomerMethod = async () => {
    const resp = await getCustomerApi();
    if (resp.status == 1) {
      setCustomerData(resp?.data);
    }
  };

  const deleteCustomerMethod = async () => {
    const resp = await deleteCustomerApi({
      c_id: rowData.c_id
    });
    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message
    });
    notify();
    if (resp.status) getCustomerMethod();
    setOpenDeleteModal({ mval: false, id: 0 });
  };

  useEffect(() => {
    getCustomerMethod();
  }, []);

  const columns = [
    {
      name: "No",
      selector: (row, index) => (page - 1) * rowsPerPage + index + 1,
      wrap: true,
      width: "70px",
      sortable: false
    },
    {
      name: "Name",
      wrap: true,
      selector: (row) => row.c_name,
      sortable: true,
      width: "150px"
    },
    {
      name: "Company Name",
      wrap: true,
      selector: (row) => row.c_company_name,
      sortable: true,
      width: "150px"
    },
    {
      name: "Email",
      wrap: true,
      selector: (row) => row.c_email,
      sortable: true,
      width: "200px"
    },
    {
      name: "Contact No",
      wrap: true,
      selector: (row) => row.c_mono,
      sortable: true,
      width: "120px"
    },
    {
      name: "GST No",
      wrap: true,
      selector: (row) => row.c_gst_no,
      sortable: true,
      width: "150px"
    },
    {
      name: "PAN No",
      wrap: true,
      selector: (row) => row.c_company_pan_no,
      sortable: true,
      width: "150px"
    },
    {
      name: "Address",
      wrap: true,
      selector: (row) => row.c_address,
      sortable: true,
      width: "150px"
    },
    {
      name: "State",
      wrap: true,
      selector: (row) => row.state_name,
      sortable: true,
      width: "120px"
    },
    {
      name: "City",
      wrap: true,
      selector: (row) => row.city_name,
      sortable: true,
      width: "120px"
    },
    {
      name: "Action",
      wrap: true,
      sortable: true,
      width: "200px",
      selector: (row) => (
        <>
          <Tooltip title="Edit Customer">
            <IconButton
              onClick={() => {
                setModalType("Edit");
                setRowData(row);
                toggleAddEditModal();
              }}
            >
              <EditSharp color="warning" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Delete Customer">
            <IconButton
              onClick={() => {
                setRowData(row);
                setOpenDeleteModal({
                  mval: true,
                  id: row.c_id
                });
              }}
            >
              <DeleteSharp color="error" />
            </IconButton>
          </Tooltip>
        </>
      )
    }
  ];

  return (
    <>
      <Container>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
              <Typography variant="h4" gutterBottom>
                Customer
              </Typography>
            </Stack>
          </Grid>
          <Grid item xs={6}>
            <Button
              onClick={() => {
                toggleAddEditModal();
                setModalType("Add");
              }}
              style={{ marginBottom: "15px", float: "right" }}
              variant="contained"
            >
              {/* Add Customer */}
              Add Customer
            </Button>
          </Grid>
        </Grid>

        <Card spacing={3} style={{ padding: "10px", marginTop: "20px" }}>
          <DataTable
            pagination
            highlightOnHover
            paginationServer={false}
            onChangePage={(p) => setPage(p)}
            paginationDefaultPage={page}
            paginationPerPage={rowsPerPage}
            onChangeRowsPerPage={(newPerPage, page) => {
              setRowsPerPage(newPerPage);
              setPage(page);
            }}
            columns={columns}
            data={customerData != null ? customerData : []}
          />
        </Card>
      </Container>
      {addEditModal && (
        <CustomerInsertUpdateModal
          addEditModal={addEditModal}
          setAddEditModal={setAddEditModal}
          modalType={modalType}
          toggleAddEditModal={toggleAddEditModal}
          rowData={rowData}
          getCustomerMethod={getCustomerMethod}
        />
      )}

      <Deletemodal
        visible={openDeleteModal}
        setVisible={setOpenDeleteModal}
        deletefunc={deleteCustomerMethod}
      />
    </>
  );
}
